import { useLocation } from 'react-router-dom';
import { getCalculatorExplainer } from '@/content/calculator-explainers';
import { HowItWorksCard } from '@/components/calculator/HowItWorksCard';

export function RouteHowItWorks() {
  const location = useLocation();
  const explainer = getCalculatorExplainer(location.pathname);

  if (!explainer) {
    return null;
  }

  return (
    <HowItWorksCard
      title={explainer.title}
      summary={explainer.summary}
      steps={explainer.steps}
      reference={explainer.reference}
    />
  );
}
